import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router-dom';
import FallbackLoaderComponent from './app/components/fallback-loader/FallbackLoader.component';
// import BaseLayout from './app/layout/baseLayout/BaseLayout.component';

const Loader = (Component) => (props) =>
    (
        <Suspense fallback={<FallbackLoaderComponent />}>
            <Component {...props} />
        </Suspense>
    );

const Page404 = Loader(lazy(() => import('./app/components/auth/PageNotFound')));
const LoginProcess2FA = Loader(lazy(() => import('./app/containers/login-process-2fa/login-process-2fa')));
const AccountList = Loader(lazy(() => import('./app/containers/accounts/Accounts')));
const BookingList = Loader(lazy(() => import('./app/containers/bookings/Bookings')));
const BookingDetails = Loader(lazy(() => import('./app/containers/bookings/BookingDetails')));
const JourneyDetails = Loader(lazy(() => import('./app/containers/bookings/BookingJourneyDetails')));
const UserDetails = Loader(lazy(() => import('./app/containers/accounts/UserDetails')));
const AirlineCopy = Loader(lazy(() => import('./app/containers/admin/airline-copy/copy.component')));

const BookingSummary = Loader(lazy(() => import('./app/containers/summary/BookingSummary')));
const DriverSummary = Loader(lazy(() => import('./app/containers/summary/AllDriverSummary')));
const WEBAlertsList = Loader(lazy(() => import('./app/containers/admin/alerts/Alerts')));
const WEBPaymentsList = Loader(lazy(() => import('./app/containers/admin/payments/Payments')));
const FlightSummary = Loader(lazy(() => import('./app/containers/summary/FlightSummary')));
const AirlineManagement = Loader(lazy(() => import('./app/containers/summary/AirlineManagement')));
const AirlineConfiguration = Loader(lazy(() => import('./app/containers/summary/AirlineConfiguration')));
const WEBUserList = Loader(lazy(() => import('./app/containers/admin/users/UsersList')));
const WEBPromoList = Loader(lazy(() => import('./app/containers/admin/promos/Promos')));
const WEBTrackingCopy = Loader(lazy(() => import('./app/containers/admin/tracking-copy/Tracking-copy.component')));
const SlaDashboard = Loader(lazy(() => import('./app/containers/admin/sla-dashboard/SlaDashboard')));
const TestBookings = Loader(lazy(() => import('./app/containers/admin/test-bookings/TestBookings')));

const AdminBookingAction = Loader(lazy(() => import('./app/containers/superAdmin/bookingAction/BookingAction')));
const AdminBookingView = Loader(lazy(() => import('./app/containers/superAdmin/bookingView/BookingView')));
const BookingPassports = Loader(lazy(() => import('./app/containers/superAdmin/bookingPassports/BookingPassports')));

interface IRoutes {
    path?: string;
    element?: JSX.Element;
    secret?: number;
    isPrivate?: boolean;
}

export const publicRoutes: RouteObject[] = [
    {
        // use it for stutus page rendering e.g 404, 401
        path: '*',
        element: <Page404 />,
    },
];

export const routes: IRoutes[] = [
    // External agent section
    {
        path: '/customer/login-process-2fa',
        element: <LoginProcess2FA />,
        isPrivate: false,
        secret: 99,
    },
    {
        path: '/',
        element: <Navigate to='/customer/bookings' replace />,
        isPrivate: false,
        secret: 5,
    },
    {
        path: '/customer',
        element: <Navigate to='/customer/bookings' replace />,
        isPrivate: true,
        secret: 5,
    },
    {
        path: '/customer/accounts',
        element: <AccountList />,
        isPrivate: true,
        secret: 6,
    },
    {
        path: '/customer/accounts/:user',
        element: <UserDetails />,
        isPrivate: true,
        secret: 6,
    },
    {
        path: '/customer/bookings',
        element: <BookingList />,
        isPrivate: true,
        secret: 5,
    },
    {
        path: '/customer/bookings/:bookingRef',
        element: <BookingDetails />,
        isPrivate: true,
        secret: 5,
    },
    {
        path: '/customer/bookings/:bookingRef/:journeyRef',
        element: <JourneyDetails />,
        isPrivate: true,
        secret: 5,
    },
    // Operations section
    {
        path: 'operations/booking-summary',
        element: <BookingSummary />,
        isPrivate: true,
        secret: 11,
    },
    {
        path: 'operations/driver-summary',
        element: <DriverSummary />,
        isPrivate: true,
        secret: 12,
    },
    {
        path: 'operations/flight-summary',
        element: <FlightSummary />,
        isPrivate: true,
        secret: 17,
    },
    {
        path: 'operations/airline-management',
        element: <AirlineManagement />,
        isPrivate: true,
        secret: 17,
    },
    {
        path: 'operations/airline-configuration',
        element: <AirlineConfiguration />,
        isPrivate: true,
        secret: 17,
    },
    // Admin/conceirge section
    {
        path: 'admin/alerts',
        element: <WEBAlertsList />,
        isPrivate: true,
        secret: 16,
    },
    {
        path: 'admin/payments',
        element: <WEBPaymentsList />,
        isPrivate: true,
        secret: 18,
    },
    {
        path: 'admin/promos',
        element: <WEBPromoList />,
        isPrivate: true,
        secret: 7,
    },
    {
        path: 'admin/users',
        element: <WEBUserList />,
        isPrivate: true,
        secret: 8,
    },
    {
        path: 'admin/airline-copy',
        element: <AirlineCopy />,
        isPrivate: true,
        secret: 9,
    },
    {
        path: 'admin/tracking-copy',
        element: <WEBTrackingCopy />,
        isPrivate: true,
        secret: 10,
    },
    {
        path: 'admin/sla-dashboard',
        element: <SlaDashboard />,
        isPrivate: true,
        secret: 15,
    },
    {
        path: 'admin/test-bookings',
        element: <TestBookings />,
        isPrivate: true,
        secret: 99,
    },
    // Super Admin section
    {
        path: 'super-admin/booking-actions',
        element: <AdminBookingAction />,
        isPrivate: true,
        secret: 13,
    },
    {
        path: 'super-admin/booking-view',
        element: <AdminBookingView />,
        isPrivate: true,
        secret: 14,
    },
    {
        path: 'super-admin/view-passports',
        element: <BookingPassports />,
        isPrivate: true,
        secret: 14,
    },
];

export default routes;
